module.exports = __webpack_public_path__ + "img/71.f21b635c.png";